var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
export function FiltersWidget(_a) {
    var children = _a.children;
    var location = useLocation();
    useEffect(function () {
        var params = new URLSearchParams(location.search);
        var raw = params.get('scrollY');
        if (raw === null)
            return;
        var y = parseInt(raw, 10);
        if (!Number.isFinite(y) || y < 0)
            return;
        // When navigating with loaders, the page may be temporarily shorter than `y`.
        // A single early `scrollTo` would get clamped to the loader "bottom" and stay there.
        // Retry for a short period until there's enough scrollable height.
        var attempts = 0;
        var maxAttempts = 20; // ~3s with 150ms interval
        var intervalMs = 150;
        var timeout = null;
        var shouldRestore = function () {
            var scrollHeight = document.documentElement.scrollHeight;
            // Require a bit of extra space below to avoid clamping to current bottom.
            return scrollHeight > y + 100;
        };
        var restore = function () {
            attempts += 1;
            if (shouldRestore()) {
                window.scrollTo(0, y);
            }
            // Stop if we've reached the desired position or we ran out of retries.
            if (Math.abs(window.scrollY - y) < 2 || attempts >= maxAttempts) {
                return;
            }
            timeout = setTimeout(restore, intervalMs);
        };
        // Start on next tick to allow React/router DOM updates before measuring height.
        timeout = setTimeout(restore, 0);
        return function () {
            if (timeout)
                clearTimeout(timeout);
        };
    }, [location.search]);
    return (_jsx("div", __assign({ className: "lg:sticky lg:top-0 z-[2] bg-white flex flex-col sm:flex-row pb-4 mb-1 gap-2 flex-wrap" }, { children: children })));
}
export default FiltersWidget;
